import panel_month_range_vue_vue_type_script_setup_true_lang_default from "./panel-month-range.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/date-picker-panel/src/date-picker-com/panel-month-range.vue
var panel_month_range_default = panel_month_range_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { panel_month_range_default as default };
//# sourceMappingURL=panel-month-range.mjs.map